import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RecipeForm } from '../components/recipes/RecipeForm';
import { Recipe, CreateRecipeDTO } from '../types/recipe';
import { recipeApi } from '../services/api';

const RecipeFormPage: React.FC<{ mode: 'create' | 'edit' }> = ({ mode }) => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [recipe, setRecipe] = React.useState<Recipe | null>(null);
  const [loading, setLoading] = React.useState(mode === 'edit');

  React.useEffect(() => {
    const fetchRecipe = async () => {
      if (mode === 'edit' && id) {
        try {
          const data = await recipeApi.get(id);
          setRecipe(data);
        } catch (error) {
          console.error('Error fetching recipe:', error);
          navigate('/recipes');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchRecipe();
  }, [mode, id, navigate]);

  if (loading) {
    return <div className="loading">Loading recipe...</div>;
  }

  const handleSubmit = async (data: CreateRecipeDTO) => {
    try {
      if (mode === 'edit' && recipe) {
        await recipeApi.update(recipe.id, data);
      } else {
        await recipeApi.create(data);
      }
      navigate('/recipes');
    } catch (error) {
      console.error(`Error ${mode === 'edit' ? 'updating' : 'creating'} recipe:`, error);
    }
  };

  return (
    <RecipeForm
      recipe={recipe || undefined}
      onSubmit={handleSubmit}
      onCancel={() => navigate('/recipes')}
    />
  );
};

export default RecipeFormPage;
